<template>
    <div class="bg-gray-200 rounded-full flex justify-between p-1 w-full" :class="`h-${sizes[size].height}`">
        <div
          class="text-white text-xl rounded-full flex justify-center items-center pt-0.5"
          @click="updateValue(modelValue - 1)"
          :class="[
            min === modelValue ? 'bg-indigo-500/70' : 'bg-indigo-500 cursor-pointer hover:bg-indigo-600',
            `w-${sizes[size].btn}`
          ]"
        >
            <span>-</span>
        </div>

        <input type="number" class="p-2 text-center outline-none" :class="`w-${sizes[size].input}`" :value="modelValue" @change="onInput" @focusin="selectAllAndPutCursorToEnd">

        <div
          class="text-white font-bold rounded-full flex justify-center items-center pt-0.5"
          @click="updateValue(modelValue + 1)"
          :class="[
            max === modelValue ? 'bg-indigo-500/70' : 'bg-indigo-500 cursor-pointer hover:bg-indigo-600',
            `w-${sizes[size].btn}`
          ]"
        >
            <span>+</span>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
        min: Number,
        max: Number,
        size: {
            type: String,
            default: 'md'
        }
    },
    methods: {
        onInput(event) {
            this.updateValue(Number(event.target.value))
        },
        updateValue(value) {
            if (value < this.min) {
                value = this.min
            } else if (value > this.max) {
                value = this.max
            }

            if (this.modelValue !== value) {
                this.$emit('update:modelValue', value)
            }
        },
        selectAllAndPutCursorToEnd (e) {
            setTimeout(() => e.target.select());
        }
    },
    setup() {
        return {
            sizes: {
                md: {
                    height: 12,
                    btn: 10,
                    input: 16
                },
                sm: {
                    height: 10,
                    btn: 8,
                    input: 12
                }
            }
        }
    }
})
</script>
